module.exports = __webpack_public_path__ + "static/img/智慧运营平台.66b77ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/智慧运营平台.jpg
// module id = tp4w
// module chunks = 1